import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Stack, Typography } from '@emburse/embark-core';
import { $t, useTranslation } from '../../../hooks/useTranslation';
import { CorpMerchantCodesContext } from '../CorpMerchantCodesProvider';
function CorpMerchantCodesHeader() {
    useTranslation();
    const { loading, merchantCodePageload } = useContext(CorpMerchantCodesContext);
    return (_jsxs(Stack, { alignItems: "flex-start", spacing: 2, sx: { width: '100%' }, children: [_jsxs(Typography, { variant: "h4", children: ["Merchant Codes: ", loading ? '...' : merchantCodePageload.PageTitle] }), _jsx(Typography, { variant: "body1", children: $t('Link merchant codes below to automatically assign credit card' +
                    ' expenses with a matching code to this category.') })] }));
}
export default CorpMerchantCodesHeader;
